import { connect, useDispatch } from "react-redux";
import { IStudentCourse } from "../../../models/dashboard/studentDashboard";
import { useEffect } from "react";
import StudentAllTermCources from "./components/studentAllTermCources";
import StudentHelp from "./components/studentHelp";
import QuickLinks from "./components/quickLinks";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { setSnapShots } from "../../../store/slices/master/snapShotSlice";
import WeekCalendar from "../../../common-components/calendar/weekCalendar";

const StudentCourses = (props: IStudentCourse) => {
  const dispatch = useDispatch();
  const { getSnapShots } = props;

  useEffect(() => {
    getSnapShots();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSnapShots([]));
    };
  }, []);

  return (
    <div className="row studcource-mobile course-wrap">
      <div className="col-lg-8 mb-3">
        <div className="card-wrap">
          <div className="title">
            <h2>Courses</h2>
          </div>
          <StudentAllTermCources />
        </div>
      </div>
      <div className="col-lg-4 mb-3">
        <div className="row h-100">
          <div className="col-md-12 mb-3">
              <QuickLinks/>
          </div>
          <div className="col-md-12">
            <StudentHelp />
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <WeekCalendar />
      </div>
    </div>
  );
};
const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentCourses);
